import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../estilo.css';

const portfolioAssets = [
  { image: require('../img/LucroTotalPotifolio.png'), imageColumn: 'col-md-7', textColumn: 'col-md-5' },
  { image: require('../img/CurvaCapitallPotifolio.png'), imageColumn: 'col-md-8', textColumn: 'col-md-4' },
  { image: require('../img/AnoTotalPotifolio.png'), imageColumn: 'col-md-7', textColumn: 'col-md-5' },
  { image: require('../img/PortifolioResultados.png'), imageColumn: 'col-md-8', textColumn: 'col-md-4' },
  { image: require('../img/CorrelacaoentreAtivos.png'), imageColumn: 'col-md-7', textColumn: 'col-md-5' },
];

export default function Portfolio() {
  const { t, i18n } = useTranslation();
  const translatedSections = t('portfolio.sections', { returnObjects: true });
  const sections = portfolioAssets.map((asset, index) => ({
    ...asset,
    ...(Array.isArray(translatedSections) ? translatedSections[index] : {}),
  }));

  return (
    <div id="portfolio" className="container-fluid bg-quant-portfolio">
      <Link to="/resultados/ragnarok" className="portfolio-live-link">{i18n.language?.startsWith('en') ? 'View Ragnarok Filas results →' : 'Ver resultados do Ragnarok Filas →'}</Link>
      <div className="text-center portfolio-header">
        <h2>{t('portfolio.title')}</h2>
        <p>{t('portfolio.intro')}</p>
        <h3 className="portfolio-highlight">{t('portfolio.highlight')}</h3>
        <p className="portfolio-subtitle">{t('portfolio.subtitle')}</p>
      </div>

      {sections.map((section) => (
        <div className="row portfolio-section" key={section.title}>
          <div className={section.imageColumn}>
            <div className="portfolio-card">
              <h4>{section.title}</h4>
              <img
                src={section.image}
                alt={section.alt}
                className="img-responsive portfolio-image"
              />
            </div>
          </div>
          <div className={section.textColumn}>
            <div className="portfolio-card">
              <h4>{section.sideTitle}</h4>
              {section.text && <p>{section.text}</p>}
              <ul className="portfolio-list">
                {section.items?.map((item) => <li key={item}>{item}</li>)}
              </ul>
              {section.note && (
                <p className="portfolio-note"><small>{section.note}</small></p>
              )}
            </div>
          </div>
        </div>
      ))}

      <div className="portfolio-disclaimer text-center">
        <p><small>{t('portfolio.disclaimer')}</small></p>
      </div>
    </div>
  );
}
